import React, { FC } from "react";
import Link from "next/link";
import { useAuth } from "@helpers/hooks/useAuth";
import { Trans, t } from "@helpers/translate";
import { SupplierNotification } from "@graphql/types";
import { Badge } from "../../../../../components/ui/Badge";

import { Avatar } from "../../../../../components/ui/Avatar";
import { Dropdown } from "../../../../../components/ui/Dropdown";
import AdminDropdown from "../AdminDropdown";
import Preferences from "../Preferences";
import { getAbsoluteUrl } from "@helpers/getAbsoluteUrl";
import { ROUTES } from "@root/routes";

export const SupplierDropdown: FC<{
  notification?: SupplierNotification;
  showCalendarAlert: boolean;
}> = ({ notification, showCalendarAlert }) => {
  const { auth, logout } = useAuth();

  if (!auth) {
    return null;
  }

  return (
    <div className="flex items-center">
      <Avatar src={auth.picture?.url} size="xs" className="mr-2" />

      <Dropdown title={auth.firstName} direction="bottomRight" minWidth="9rem">
        <Link
          href="/auth/messages"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Badge count={notification?.unReadMessagesCount}>
              <Trans id="navbar.messages">Messages</Trans>
            </Badge>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/supplier/analytics"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.analytics">Analytics</Trans>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/supplier/bookings"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Badge count={notification?.paidBookingsCount}>
              <Trans id="navbar.bookings">Bookings</Trans>
            </Badge>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/supplier/calendar"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <div className="relative inline-block">
              <Trans id="navbar.calendar">Calendar</Trans>
              {showCalendarAlert && (
                <span className="absolute -top-2 -right-4 bg-primary text-white rounded-full w-4 h-4 flex items-center justify-center text-xs font-bold">
                  !
                </span>
              )}
            </div>
          </Dropdown.Item>
        </Link>
        <Dropdown.Divider />
        <Link
          href="/auth/account"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.account">Account</Trans>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/posts"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.blog">Blog</Trans>
          </Dropdown.Item>
        </Link>

        <Link
          href="/auth/payments/month"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.payments">Payments</Trans>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/supplier/reviews"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Badge count={notification?.reviewNotRepliedCount}>
              <Trans id="navbar.reviews">Reviews</Trans>
            </Badge>
          </Dropdown.Item>
        </Link>
        <Link
          href="/auth/supplier/tours"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.tours">Tours</Trans>
          </Dropdown.Item>
        </Link>

        <Link
          href={getAbsoluteUrl(ROUTES.auth.loyalty())}
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.reviews">Loyalty Program</Trans>
          </Dropdown.Item>
        </Link>

        <Dropdown.Divider />
        <Link
          href="/support"
          title={t({
            id: "common.link.title",
            message: "GoWithGuide - Private Tours & Local Tour Guides",
          })}
        >
          <Dropdown.Item>
            <Trans id="navbar.help">Help</Trans>
          </Dropdown.Item>
        </Link>

        <Dropdown.Divider />
        <Dropdown.Item>
          <Preferences />
        </Dropdown.Item>

        {auth.isAdmin && <AdminDropdown />}
        <Dropdown.Divider />

        <Dropdown.Item onClick={() => logout("", true)}>
          <Trans id="navbar.logout">Logout</Trans>
        </Dropdown.Item>
      </Dropdown>
    </div>
  );
};

export default SupplierDropdown;
